// extracted by mini-css-extract-plugin
export default {"card":"FitnessIndex_card__I-FGr"};